/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';

import Editor from '../fw/Editor.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'userEdit.profileTitle', 'defaultMessage': 'Edit profile'}
});

interface UserEditProps {
    intl: IntlShape;
    user: User;
}

class UserEdit extends React.Component<UserEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    static contextTypes = {
        router: PropTypes.object
    };

    typeName = 'users';

    constructor() {
        super();
    }

    _onSuccess = () => {
        this.context.router.push("/settings/");
    };

    render() {
        let data = this.props.user;
        let type = types[this.typeName];

		let name = [data.firstname, data.surname].filter(item => !!item).join(' ');

		if (!name) {
			name = data.email;
		}

		let lastOrganisationId = getLastOrganisationId();
        /* ugly hack to set organisation_id so we can use our URL mapping system */
        data['organisation_id'] = lastOrganisationId;

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)}>
				<h2>{this.props.intl.formatMessage(messages.title)}</h2>

                <Editor
						cancelable
						columns={['firstname', 'surname', 'nickname', 'company', 'phoneNumber', 'otherEmails', 'notifyErrors', 'notifyEmail', 'notifyErrorsFreq']}
                        data={data}
                        fatQuery={Relay.QL `fragment on UpdateUserPayload {
                            updatedNode {
                                id,
                                realId,
                                firstname,
                                surname,
                                phoneNumber,
                                otherEmails,
                                nickname,
                                company,
                                notifyErrors,
                                notifyEmail,
                                notifyErrorsFreq
                            }
                        }`}
                        metadata={type}
                        mutation={Relay.QL `mutation { updateUser }`}
                        onSuccess={this._onSuccess}
                        organisationId={this.props.user.organisation_id}
                        redirectToList
                        urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(injectIntl(UserEdit), {
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                firstname,
                surname,
                phoneNumber,
                nickname,
                otherEmails,
                email,
                company,
                notifyErrors,
                notifyEmail,
                notifyErrorsFreq,
            }
        `,
    },
});
